import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

/** /tree çıktısını (value,label,children) -> react-select options (girintili) */
const flattenTreeForSelect = (nodes, level = 0) =>
  nodes.flatMap((n) => {
    const indent = "\u00A0".repeat(level * 3); // her seviye 3 boşluk
    const opt = {
      value: n.value, // backend /tree 'value' döndürüyor
      label: `${indent}${level ? "↳ " : ""}${n.label}`,
    };
    const kids = Array.isArray(n.children)
      ? flattenTreeForSelect(n.children, level + 1)
      : [];
    return [opt, ...kids];
  });

const FeatureCreate = () => {
  const navigate = useNavigate();
  const API = process.env.REACT_APP_API_BASE_URL;
  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, def) => translations[key] || def;
  const [categories, setCategories] = useState([]);

  const [form, setForm] = useState({
    title: "",
    category_ids: [],
    is_required: false,
    is_multi: false,
    input_type: "none",
    values: "",
  });

  const [displayMode, setDisplayMode] = useState("none-single"); // default tekli seçim kutusu

  useEffect(() => {
    // UI değişince backend fieldlarını sync et
    if (displayMode === "none-single") {
      setForm({ ...form, is_multi: false, input_type: "none" });
    }
    if (displayMode === "none-multi") {
      setForm({ ...form, is_multi: true, input_type: "none" });
    }
    if (displayMode === "select-single") {
      setForm({ ...form, is_multi: false, input_type: "select" });
    }
    if (displayMode === "select-multi") {
      setForm({ ...form, is_multi: true, input_type: "select" });
    }
  }, [displayMode]);

  useEffect(() => {
    axios.get(`${API}/api/stock-categories/tree`).then((res) => {
      const flat = flattenTreeForSelect(res.data);
      setCategories(flat);
    });
  }, [API]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      title: form.title?.trim(),
      is_required: !!form.is_required,
      is_multiple: !!form.is_multi,
      category_ids: (form.category_ids || []).map((x) => x.value),
      input_type: form.input_type,
      values: (form.values || "")
        .split(",")
        .map((v) => v.trim())
        .filter(Boolean),
    };

    await axios.post(`${API}/api/features/create`, payload);
    toast.success(getText("FEATURE_CREATED_SUCCESS"));

    navigate("/features/table");
  };

  return (
    <div className="container mt-4 card p-4">

      <form onSubmit={handleSubmit}>
        <label className="form-label fw-bold"> {getText("INCLUDED_CATEGORIES_LABEL")}</label>
        <Select
          isMulti
          options={categories}
          value={form.category_ids}
          onChange={(v) => setForm({ ...form, category_ids: v || [] })}
        />
        <label className="form-label fw-bold mt-3">{getText("DATA_INPUT_LABEL")}</label>
        <div className="form-check mb-1">
          <input
            className="form-check-input"
            type="checkbox"
            checked={form.is_required}
            onChange={(e) =>
              setForm({ ...form, is_required: e.target.checked })
            }
          />
          <label className="form-check-label">{getText("REQUIRED_LABEL")}</label>
        </div>

        <label className="form-label fw-bold mt-3">
         {getText("DISPLAY_TYPE_LABEL")}
        </label>

        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name="ftype"
            value="none-single"
            checked={displayMode === "none-single"}
            onChange={(e) => setDisplayMode(e.target.value)}
          />
          <label className="form-check-label">{getText("SINGLE_BOX_OPTION")}</label>
        </div>

        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name="ftype"
            value="none-multi"
            checked={displayMode === "none-multi"}
            onChange={(e) => setDisplayMode(e.target.value)}
          />
          <label className="form-check-label">{getText("MULTI_BOX_OPTION")}</label>
        </div>

        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name="ftype"
            value="select-single"
            checked={displayMode === "select-single"}
            onChange={(e) => setDisplayMode(e.target.value)}
          />
          <label className="form-check-label">{getText("SINGLE_SELECT_OPTION")}</label>
        </div>

        <div className="form-check mb-3">
          <input
            className="form-check-input"
            type="radio"
            name="ftype"
            value="select-multi"
            checked={displayMode === "select-multi"}
            onChange={(e) => setDisplayMode(e.target.value)}
          />
          <label className="form-check-label">  {getText("FEATURE_TITLE_LABEL")}</label>
        </div>

        <label className="form-label fw-bold"> placeholder={getText("FEATURE_TITLE_PLACEHOLDER")}</label>
        <input
          className="form-control mb-3"
          placeholder="ex: color"
          value={form.title}
          onChange={(e) => setForm({ ...form, title: e.target.value })}
        />

        <label className="form-label fw-bold"> {getText("VALUES_LABEL")}</label>
        <input
          className="form-control mb-3"
            placeholder={getText("VALUES_PLACEHOLDER")}
          value={form.values}
          onChange={(e) => setForm({ ...form, values: e.target.value })}
        />

        <div className="d-flex justify-content-center">
          <button type="submit" className="btn btn-primary">
             {getText("SAVE")}
          </button>
        </div>
      </form>
    </div>
  );
};

export default FeatureCreate;
